interface Domain {
  Domain: string;
}

const isValidDomain = (email: string | null, validDomains: Domain[]): boolean => {
  const domain = (email && email.includes("@")) ? email.split('@')[1].toLowerCase() : ""
  if (!domain) {
    return false
  }
  return validDomains.some(domainObj => domainObj.Domain.toLowerCase() === domain)
};


export default isValidDomain